import { ActionType } from 'typesafe-actions';
import { getADICategories } from '../../api/adiCategories/adiCategories';
import { Thunk } from '../rootReducer';
import * as actions from './actions';
import { VideoType } from './types';

function setVideoType(
  value: VideoType,
): Thunk<
  ActionType<typeof actions.setVideoType | typeof actions.setPersonalCategory>
> {
  return (dispatch, getState) => {
    const isPersonal = value === VideoType.PERSONAL;

    dispatch(actions.setVideoType(value));

    if (isPersonal) {
      void getADICategories({
        query: 'coming soon landing page',
        sessionId: '1234-1234-12341234',
      }).then((fetchedCategories) =>
        dispatch(actions.setPersonalCategory(fetchedCategories[0])),
      );
    }
  };
}

export {
  setPersonalCategory,
  setBusinessCategory,
  setBusinessName,
  setVideoPurpose,
} from './actions';
export { setVideoType };
